/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_All_PlansInputs */

const en_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all plans`)
};

const ar_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض كل الخطط`)
};

const de_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Pläne anzeigen`)
};

const es_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los planes`)
};

const fr_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tous les plans`)
};

const it_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza tutti i piani`)
};

const ja_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全プランを見る`)
};

const ko_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 플랜 보기`)
};

const pt_br_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os planos`)
};

const ru_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть все планы`)
};

const th_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูแผนทั้งหมด`)
};

const tr_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm planları görüntüle`)
};

const zh_cn_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有方案`)
};

const zh_tw_view_all_plans = /** @type {(inputs: View_All_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有方案`)
};

/**
* | output |
* | --- |
* | "View all plans" |
*
* @param {View_All_PlansInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const view_all_plans = /** @type {((inputs?: View_All_PlansInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_All_PlansInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_all_plans(inputs)
	if (locale === "ar") return ar_view_all_plans(inputs)
	if (locale === "de") return de_view_all_plans(inputs)
	if (locale === "es") return es_view_all_plans(inputs)
	if (locale === "fr") return fr_view_all_plans(inputs)
	if (locale === "it") return it_view_all_plans(inputs)
	if (locale === "ja") return ja_view_all_plans(inputs)
	if (locale === "ko") return ko_view_all_plans(inputs)
	if (locale === "pt_br") return pt_br_view_all_plans(inputs)
	if (locale === "ru") return ru_view_all_plans(inputs)
	if (locale === "th") return th_view_all_plans(inputs)
	if (locale === "tr") return tr_view_all_plans(inputs)
	if (locale === "zh_cn") return zh_cn_view_all_plans(inputs)
	return zh_tw_view_all_plans(inputs)
});